import React, { useState, useEffect } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '../Styles/Button.module.css';
import Modal from 'react-bootstrap/Modal'
import Style from '../Styles/DashboardStyle.module.css';
import { Link, useNavigate } from 'react-router-dom';
import DashboardTitle from "./DashboardTitle";
import DashBoardLeftProfileMenu from "./DashBoardLeftProfileMenu";
import { getUserBussinessListFormData,getBussinessDeleteFormData } from "../../services/routes.services";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import constants from "../../services/constants";
import { useSelector } from 'react-redux';
import { IoMdClose } from "react-icons/io";
const BussinessListing = ()=>{
    const [showData, setShowData] = useState(false);
    const [getAllData, setGetAllData] = useState(null);
    const [getDetails, setDetails] = useState([]);
    const [deleteData, setDeleteData] = useState(null); 
    const [deleteModal, setDeleteModal] = useState(false);

    const openDeleteHandler = (data) => {
        setDeleteData(data);
        setDeleteModal(true);
    };
    const closeDeleteHandler = () => {
        setDeleteModal(false);
        setDeleteData(null);
    };
    

    const handleClose = () => setShowData(false);
    const handleShow = (Busnisslist) => {
        setShowData(true);
        setDetails(Busnisslist);
    }
    
    const { token } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    useEffect(() => {
        getAlluserBusinesslisting(token)
    }, []);
    const getAlluserBusinesslisting=(token)=>{
        getUserBussinessListFormData(token)
        .then((res) => {
            setGetAllData(res.data.business);
            setDetails(res.data.business[0])
           
        })
        .catch((error) => {
            console.log(error);
        });
    }
    const handleEditPage=(Busnisslist)=>{
        navigate("/business-directory-create", { state: { Busnisslist: Busnisslist } });
    }
    const handleDeleteListing = (data) => {
        getBussinessDeleteFormData(data._id, token)
            .then((res) => {
                if (res.status === 200) {
                    toast.success(res.data.message, {
                        position: "top-right",
                        type: 'success',
                    });
                    getAlluserBusinesslisting(token); // Refresh the list
                } else {
                    toast.error(res.data.message, {
                        position: "top-right",
                        type: 'error',
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                closeDeleteHandler(); 
            });
    };

    return( 
        <div><DashBoardLeftProfileMenu/>
         <div className={'containerStyla  ' + Style.Dashboardscreen +" "+Style.BussinesList}>
            <ToastContainer />
            <Container>
                <DashboardTitle title="Business Listing" membertype="Non Member" />
                <Row className={Style.space}>
            <Col lg={6} className={Style.order2}>
                <h3 className={Style.dashboardSubTitle}>YOUR LISTINGS</h3>
                {getAllData && (
                    <>{getAllData.map((Busnisslist)=>{
                        return(
                            <div className={Style.jobList} key={Busnisslist._id}>
                            <figure>
                                    <img src={constants.IMAGE_BASE_URL+'business/'+Busnisslist.image} alt={Busnisslist.name} />
                            </figure>
                            {Busnisslist.name && (<h4> {Busnisslist.name}</h4>)}
                            {Busnisslist.designation && (<p> {Busnisslist.designation}</p>)}
                            {Busnisslist.categoryId && (<span> {Busnisslist.categoryId.name}</span>)}
                        
                            <ul>
                                <li><a  href="#" onClick={(e) => {e.preventDefault();handleShow(Busnisslist)}} className={Style.discountBtn}>More Details</a></li>
                                <li><a  href="#" onClick={(e) => {e.preventDefault();handleEditPage(Busnisslist)}}>Edit</a></li>
                                <li><a  href="#" onClick={(e) => {e.preventDefault();openDeleteHandler(Busnisslist)}}>Delete Listing</a> 
                                <Modal className='deleteContant' show={deleteModal} onHide={closeDeleteHandler} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                                    <Modal.Body><p>Are you sure you want to delete this listing?</p></Modal.Body>
                                    <Modal.Footer>
                                        <button type="button" className={Button.brownBorderBtn} onClick={closeDeleteHandler}>No</button>
                                        <button type="button" className={Button.greenBtn} onClick={() => handleDeleteListing(deleteData)} autoFocus>Yes</button>
                                    </Modal.Footer>
                                </Modal>
                                </li>
                            </ul>
                            {showData &&
                                <div className={Style.popOverlay}>
                                    <div className={Style.discountPopup}>
                                        <button type="button" className={Style.closePopup} onClick={handleClose}><IoMdClose /></button>
                                        <div className={Style.discountDetails}>
                                            <div className={Style.companyLogo}>
                                                    <img src={constants.IMAGE_BASE_URL+'/business/'+Busnisslist.image} />
                                            </div>
                                            <div className={Style.offerHead}>
                                                <h2>{Busnisslist.name}
                                                </h2>
                                                <p>{Busnisslist.categoryId.name}</p>
                                            </div>
                                            <div className={Style.offerDetails}>
                                                <table role="none">
                                                    <tbody><tr>
                                                        <td className={Style.left}>Business Name</td>
                                                        <td className={Style.right}>{Busnisslist.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={Style.left}>Category</td>
                                                        <td className={Style.right}>{Busnisslist.categoryId.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={Style.left}>Description</td>
                                                        <td className={Style.right}>{Busnisslist.description}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={Style.left}>Business Contact No.</td>
                                                        <td className={Style.right}>{Busnisslist.phone}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={Style.left}>CITY</td>
                                                        <td className={Style.right}>{Busnisslist.city.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={Style.left}>Country</td>
                                                        <td className={Style.right}>{Busnisslist.country.name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={Style.left}>Alumni Member name</td>
                                                        <td className={Style.right}>{Busnisslist.username}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className={Style.left}>Designation</td>
                                                        <td className={Style.right}>{Busnisslist.designation}</td>
                                                    </tr>

                                                    <tr>
                                                        <td className={Style.left}>Batch</td>
                                                        <td className={Style.right}>2000</td>
                                                    </tr>
                                                </tbody></table>
                                            </div>
                                            <a href="#" onClick={(e) => {e.preventDefault();handleEditPage(Busnisslist)}} className={Style.greenBtn}>Edit</a>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        )
                    })}
                    </>
                )}       
            </Col>
            <Col lg={6} className={Style.paddL + " " + Style.order1}>
                <div className={Style.addJobList}>
                    <h4>Add New Business Listing</h4>
                    <Link to="/business-directory-create" className={Style.greenBtn} >Click Here</Link>
                </div>
            </Col>
            </Row>
            </Container>
        </div>
        </div>
        )
    }
    
    export default BussinessListing;